export const extractPathname = (path) => {
  return path.split('/')
}
